import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-433b3612"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4 space-y-3" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "space-y-3" }
const _hoisted_4 = { class: "grid-2 items-end" }
const _hoisted_5 = { class: "grid-2 items-end" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "dark-muted" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "flex-grow space-y-3 pl-4 border-l ml-4" }
const _hoisted_10 = { class: "flex space-x-3 items-end" }
const _hoisted_11 = { class: "w-1/3" }
const _hoisted_12 = { class: "flex space-x-3 items-end" }
const _hoisted_13 = { class: "w-1/3" }
const _hoisted_14 = { class: "grid-2 items-end" }
const _hoisted_15 = { class: "grid-2" }
const _hoisted_16 = { class: "flex items-stretch space-x-3" }
const _hoisted_17 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-6" }, [
  /*#__PURE__*/_createElementVNode("svg", { id: "barcode" })
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_21 = { class: "flex justify-end space-x-3" }


const __default__ = {
  name: 'ModalManageItem',
}

import { computed, nextTick, ref, watch } from 'vue';
import { v4 as uuid } from 'uuid';
import JSBarcode from 'jsbarcode';

import { ItemResource } from '@shared/resources/item';
import { ItemCreateUpdateDto } from '@shared/dto/item';
import { QtyUnit, QtyUnitNameMap } from '@shared/types/qty-unit';
import { CategoryResource } from '@shared/resources/category';
import { itemCreateUpdateSchema } from '@shared/validation/item';

import { useCategoriesStore } from '@/stores/dictionary/categories';
import { useSelectClientDataManager } from '@ui-kit/inputs/select/select-data-managers/use-select-client-data-manager';
import { useI18n } from 'vue-i18n';
import { useValidator } from '@/libs/validator/hooks/use-validator';
import { useEmitter } from '@/plugins/mitt/mitt';
import { useModalControls } from '@components/modals/hooks/use-modal-controls';
import { useModalsStore } from '@/stores/modals';
import { ItemService } from '@/services/item.service';

import BaseModal from '@/components/modals/BaseModal.vue';
import ImageUpload from '@ui-kit/inputs/image-upload/ImageUpload.vue';
import Label from '@ui-kit/label/Label.vue';
import ValidationKeyObserver from '@components/validation/ValidationKeyObserver.vue';
import SingleLine from '@ui-kit/inputs/single-line/SingleLine.vue';
import SingleSelect from '@ui-kit/inputs/select/SingleSelect.vue';
import MultiLine from '@ui-kit/inputs/multi-line/MultiLine.vue';
import Button from '@ui-kit/controls/button/Button.vue';
import ModalManageCategory from '@/pages/app/dictionary/categories/modals/ModalManageCategory.vue';
import { useScanner } from '@/libs/scanner/use-scanner';
import TransitionExpanded from '@ui-kit/transition/TransitionExpanded.vue';
import { convertEmptyStringToNull, convertToNull } from '@/helpers/data-transform';
import ItemCompanySelect from '@/pages/partials/item-company-select/ItemCompanySelect.vue';
import { ItemCompanyResource } from '@shared/resources/item-company';
import ModalManageItemCompany from '../../dictionary/item-companies/modals/ModalManageItemCompany.vue';
import CurrencySelect from '../../../partials/currency-select/CurrencySelect.vue';
import Checkbox from '@ui-kit/inputs/checkbox/Checkbox.vue';
import { Currency } from '@shared/types/currency';
import { useAutoSalePrice } from '../../../../helpers/auto-sale-price';

interface QtyUnitItem {
  id: number;
  name: string;
}
interface Props {
  data?: ItemResource;
  barcode?: string;
}
interface Emits {
  (type: 'save', value: ItemResource): void;
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    data: null,
    barcode: null
  },
  emits: ["save"],
  setup(__props: any, { emit }: { emit: ({
  (type: 'save', value: ItemResource): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  data?: ItemResource;
  barcode?: string;
}

const { t } = useI18n();
const { close } = useModalControls();
const emitter = useEmitter();
const categoriesStore = useCategoriesStore();
const modalsStore = useModalsStore();
const itemService = new ItemService();

const qtyUnits: QtyUnitItem[] = [QtyUnit.un, QtyUnit.m, QtyUnit.kg, QtyUnit.l].map((unit) => ({
  id: unit,
  name: t(`common.units.${QtyUnitNameMap[unit]}`),
}));





const showBarcodeImage = ref<boolean>(false);
const barcodeBlocked = ref<boolean>((!!props.data?.id && props.data.barcode.length > 0) || !!props.barcode);
const pending = ref<boolean>(false);
const formData = ref<ItemCreateUpdateDto>({
  name: props.data?.name || '',
  short_name: props.data?.short_name || '',
  print_name: props.data?.print_name || '',
  sale_price: props.data?.sale_price || '',
  sale_price_currency: props.data?.sale_price_currency || Currency.UAH,
  purchase_price: props.data?.purchase_price || '',
  purchase_price_currency: props.data?.purchase_price_currency || Currency.UAH,
  sale_price_auto: props.data?.sale_price_auto || false,
  sale_price_auto_percentage: props.data?.sale_price_auto_percentage || false,
  qty: props.data?.qty || '',
  min_stock_qty: props.data?.min_stock_qty || '',
  max_stock_qty: props.data?.max_stock_qty || '',
  qty_type: props.data?.qty_type || QtyUnit.un,
  barcode: props.data?.barcode || props.barcode || '',
  notes: props.data?.notes || '',
  category_id: props.data?.category?.id || null,
  item_company_id: props.data?.item_company?.id || null,
  files: props.data?.files || [],
});
useScanner((scanned) => {
  if (!barcodeBlocked.value) {
    formData.value.barcode = scanned;
  }
});
function generateBarcode() {
  formData.value.barcode = `$${uuid()}`.slice(0, 9);
}
const barcodeShowOptions = computed(() => {
  return {
    value: formData.value.barcode || '',
    show: showBarcodeImage.value,
  };
});
const isShowBarcode = computed(() => {
  return barcodeShowOptions.value.show && barcodeShowOptions.value.value.length > 0;
})
watch(barcodeShowOptions, (value) => {
  if (isShowBarcode.value) {
    nextTick(() => {
      JSBarcode('#barcode', value.value, {
        height: 48,
        displayValue: false,
        lineColor: '#081073',
        margin: 0,
      });
    });
  }
});

const generateAutoPrice = useAutoSalePrice();
const autoPrice = computed(() => generateAutoPrice({
  ...formData.value,
  purchase_price: formData.value.purchase_price || '',
  purchase_price_currency: formData.value.purchase_price_currency || Currency.UAH,
}));
const salePriceLabel = computed(() => {
  const { sale_price_auto, sale_price_auto_percentage } = formData.value;
  if (sale_price_auto) {
    const percentage = sale_price_auto_percentage ? ' (%)' : '';
    return t('pages.items.auto-price-sale-adjustment') + percentage;
  }
  return t('fields.sale_price');
});

const serverData = computed(() => {
  const data = convertToNull(formData.value);
  if (!data.sale_price_auto) {
    data.sale_price_auto_percentage = false;
  }
  return data;
})

const validator = useValidator({
  data: serverData,
  schema: computed(() => itemCreateUpdateSchema),
});

const selectedItemCompany = ref<ItemCompanyResource | undefined | null>(props.data?.item_company);
watch(selectedItemCompany, (value) => {
  formData.value.item_company_id = value ? value.id : null;
});
function addItemCompany() {
  modalsStore.addModal({
    component: ModalManageItemCompany,
    events: {
      save(value: ItemCompanyResource) {
        selectedItemCompany.value = value;
      },
    },
  });
}

const selectedCategory = computed<CategoryResource | undefined>(() => {
  return formData.value.category_id
    ? categoriesStore.data.find(({id}) => id === formData.value.category_id)
    : undefined;
});
function chooseCategory(category?: CategoryResource) {
  formData.value.category_id = category?.id || null;
}
const categorySelectManager = useSelectClientDataManager({
  selected: selectedCategory,
  data: computed(() => categoriesStore.data),
  hideSelected: true,
});

const selectedQtyUnit = computed<QtyUnitItem>(() => {
  return qtyUnits.find((unit) => unit.id === formData.value.qty_type) as QtyUnitItem;
});
function chooseQtyUnit(unit: QtyUnitItem) {
  formData.value.qty_type = unit.id;
}
const qtyUnitSelectManager = useSelectClientDataManager({
  selected: selectedQtyUnit,
  data: ref(qtyUnits),
  hideSelected: true,
});

function addCategory() {
  modalsStore.addModal({
    component: ModalManageCategory,
    events: {
      save(category: CategoryResource) {
        formData.value.category_id = category.id;
      }
    }
  })
}

function save() {
  if (validator.validate()) {
    function successCallback(item: ItemResource) {
      emit('save', item);
      if (props.data?.id) {
        emitter.emit('updateItem', item);
      } else {
        emitter.emit('addItem', item);
      }
      close();
    }

    pending.value = true;
    if (props.data?.id) {
      itemService
        .update(props.data.id, convertEmptyStringToNull(formData.value))
        .useValidator(validator)
        .send()
        .then((response) => {
          successCallback(response.data);
        })
        .finally(() => {
          pending.value = false;
        });
    } else {
      itemService
        .add(convertEmptyStringToNull(formData.value))
        .useValidator(validator)
        .send()
        .then((response) => {
          successCallback(response.data);
        })
        .finally(() => {
          pending.value = false;
        });
    }
  }
}


return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createBlock(BaseModal, {
    title: __props.data?.id ? _ctx.$t('pages.items.edit-label') : _ctx.$t('pages.items.create-label'),
    size: "xxl",
    "no-body-padding": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ImageUpload, {
              modelValue: formData.value.files,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.files) = $event)),
              width: 350,
              class: "flex-shrink-0",
              style: {"margin-bottom":"18px"},
              multiple: ""
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(Label, {
                required: formData.value.sale_price_auto,
                label: _unref(t)('fields.purchase_price')
              }, {
                default: _withCtx(({ id }) => [
                  _createVNode(ValidationKeyObserver, { keys: "purchase_price" }, {
                    default: _withCtx(({ firstErrorMessage }) => [
                      _createVNode(SingleLine, {
                        modelValue: formData.value.purchase_price,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.purchase_price) = $event)),
                        id: id,
                        errors: firstErrorMessage,
                        type: "number"
                      }, null, 8, ["modelValue", "id", "errors"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["required", "label"]),
              _createVNode(CurrencySelect, {
                "hide-empty": "",
                modelValue: formData.value.purchase_price_currency,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.purchase_price_currency) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(Label, {
                required: "",
                label: _unref(salePriceLabel)
              }, {
                default: _withCtx(({ id }) => [
                  _createVNode(ValidationKeyObserver, { keys: "sale_price" }, {
                    default: _withCtx(({ firstErrorMessage }) => [
                      _createVNode(SingleLine, {
                        modelValue: formData.value.sale_price,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.sale_price) = $event)),
                        id: id,
                        errors: firstErrorMessage,
                        type: "number"
                      }, null, 8, ["modelValue", "id", "errors"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["label"]),
              (!formData.value.sale_price_auto || !formData.value.sale_price_auto_percentage)
                ? (_openBlock(), _createBlock(CurrencySelect, {
                    key: 0,
                    "hide-empty": "",
                    modelValue: formData.value.sale_price_currency,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.sale_price_currency) = $event))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createVNode(Checkbox, {
                modelValue: formData.value.sale_price_auto,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.sale_price_auto) = $event)),
                label: _ctx.$t('pages.items.auto-price')
              }, null, 8, ["modelValue", "label"])
            ]),
            (formData.value.sale_price_auto)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(Checkbox, {
                    modelValue: formData.value.sale_price_auto_percentage,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.sale_price_auto_percentage) = $event)),
                    label: _ctx.$t('pages.items.auto-price-percent')
                  }, null, 8, ["modelValue", "label"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.$t('fields.sale_price_local')) + " ", 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(autoPrice)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Label, {
              label: _unref(t)('fields.name'),
              required: ""
            }, {
              default: _withCtx(({id}) => [
                _createVNode(ValidationKeyObserver, { keys: "name" }, {
                  default: _withCtx(({ firstErrorMessage }) => [
                    _createVNode(SingleLine, {
                      modelValue: formData.value.name,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.name) = $event)),
                      id: id,
                      errors: firstErrorMessage
                    }, null, 8, ["modelValue", "id", "errors"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(Label, {
              label: _unref(t)('fields.short_name'),
              tooltip: _ctx.$t('pages.items.tooltips.short_name')
            }, {
              default: _withCtx(({id}) => [
                _createVNode(ValidationKeyObserver, { keys: "short_name" }, {
                  default: _withCtx(({ firstErrorMessage }) => [
                    _createVNode(SingleLine, {
                      modelValue: formData.value.short_name,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.short_name) = $event)),
                      id: id,
                      errors: firstErrorMessage
                    }, null, 8, ["modelValue", "id", "errors"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["label", "tooltip"]),
            _createVNode(Label, {
              label: _unref(t)('fields.print_name')
            }, {
              default: _withCtx(({id}) => [
                _createVNode(ValidationKeyObserver, { keys: "print_name" }, {
                  default: _withCtx(({ firstErrorMessage }) => [
                    _createVNode(SingleLine, {
                      modelValue: formData.value.print_name,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.print_name) = $event)),
                      id: id,
                      errors: firstErrorMessage
                    }, null, 8, ["modelValue", "id", "errors"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["label"]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(Label, {
                label: _unref(t)('fields.category'),
                class: "w-2/3"
              }, {
                default: _withCtx(({id}) => [
                  _createVNode(ValidationKeyObserver, { keys: "category_id" }, {
                    default: _withCtx(({ firstErrorMessage }) => [
                      _createVNode(SingleSelect, {
                        "data-manager": _unref(categorySelectManager),
                        "model-value": _unref(selectedCategory),
                        "onUpdate:modelValue": chooseCategory,
                        errors: firstErrorMessage,
                        "select-option-text": _ctx.$t('pages.items.select-category')
                      }, null, 8, ["data-manager", "model-value", "errors", "select-option-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["label"]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(Button, {
                  onClick: addCategory,
                  class: "w-full",
                  "button-type": "outline",
                  size: "xl"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('common.actions.new')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(Label, {
                label: _unref(t)('fields.item-company'),
                class: "w-2/3"
              }, {
                default: _withCtx(({id}) => [
                  _createVNode(ValidationKeyObserver, { keys: "item_company_id" }, {
                    default: _withCtx(({ firstErrorMessage }) => [
                      _createVNode(ItemCompanySelect, {
                        modelValue: selectedItemCompany.value,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedItemCompany).value = $event)),
                        errors: firstErrorMessage
                      }, null, 8, ["modelValue", "errors"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["label"]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(Button, {
                  onClick: addItemCompany,
                  class: "w-full",
                  "button-type": "outline",
                  size: "xl"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('common.actions.new')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(Label, {
                required: "",
                label: _unref(t)('fields.qty'),
                class: "basis-0 flex-grow"
              }, {
                default: _withCtx(({ id }) => [
                  _createVNode(ValidationKeyObserver, { keys: "qty" }, {
                    default: _withCtx(({ firstErrorMessage }) => [
                      _createVNode(SingleLine, {
                        modelValue: formData.value.qty,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.qty) = $event)),
                        id: id,
                        errors: firstErrorMessage,
                        type: "number"
                      }, null, 8, ["modelValue", "id", "errors"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(ValidationKeyObserver, { keys: "qty_type" }, {
                default: _withCtx(({ firstErrorMessage }) => [
                  _createVNode(SingleSelect, {
                    "model-value": _unref(selectedQtyUnit),
                    "onUpdate:modelValue": chooseQtyUnit,
                    "data-manager": _unref(qtyUnitSelectManager),
                    "disable-search": "",
                    "hide-empty": "",
                    errors: firstErrorMessage,
                    "select-option-text": _ctx.$t('pages.items.select-qty-type')
                  }, null, 8, ["model-value", "data-manager", "errors", "select-option-text"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(Label, {
                label: _unref(t)('fields.min_stock_qty'),
                tooltip: _ctx.$t('pages.items.tooltips.min_stock_qty'),
                class: "basis-0 flex-grow"
              }, {
                default: _withCtx(({ id }) => [
                  _createVNode(ValidationKeyObserver, { keys: "min_stock_qty" }, {
                    default: _withCtx(({ firstErrorMessage }) => [
                      _createVNode(SingleLine, {
                        modelValue: formData.value.min_stock_qty,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.min_stock_qty) = $event)),
                        id: id,
                        errors: firstErrorMessage,
                        type: "number"
                      }, null, 8, ["modelValue", "id", "errors"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["label", "tooltip"]),
              _createVNode(Label, {
                label: _unref(t)('fields.max_stock_qty'),
                class: "basis-0 flex-grow",
                tooltip: _ctx.$t('pages.items.tooltips.max_stock_qty')
              }, {
                default: _withCtx(({ id }) => [
                  _createVNode(ValidationKeyObserver, { keys: "max_stock_qty" }, {
                    default: _withCtx(({ firstErrorMessage }) => [
                      _createVNode(SingleLine, {
                        modelValue: formData.value.max_stock_qty,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.max_stock_qty) = $event)),
                        id: id,
                        errors: firstErrorMessage,
                        type: "number"
                      }, null, 8, ["modelValue", "id", "errors"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["label", "tooltip"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(Label, {
                label: _unref(t)('fields.barcode')
              }, {
                default: _withCtx(({ id }) => [
                  _createVNode(ValidationKeyObserver, { keys: "barcode" }, {
                    default: _withCtx(({ firstErrorMessage }) => [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(SingleLine, {
                          class: "flex-grow",
                          modelValue: formData.value.barcode,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.barcode) = $event)),
                          disabled: barcodeBlocked.value,
                          id: id,
                          errors: firstErrorMessage
                        }, null, 8, ["modelValue", "disabled", "id", "errors"]),
                        (barcodeBlocked.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "barcode-button",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (barcodeBlocked.value = false))
                            }, [
                              _createVNode(_component_FontAwesomeIcon, { icon: "lock" })
                            ]))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "barcode-button",
                              onClick: generateBarcode
                            }, [
                              _createVNode(_component_FontAwesomeIcon, { icon: "sync-alt" })
                            ])),
                        _createElementVNode("div", {
                          class: "barcode-button barcode-button-eye",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (showBarcodeImage.value = !showBarcodeImage.value))
                        }, [
                          _createVNode(_component_FontAwesomeIcon, {
                            icon: "eye",
                            class: _normalizeClass({
                        'opacity-30': !showBarcodeImage.value,
                      })
                          }, null, 8, ["class"])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(TransitionExpanded, null, {
                default: _withCtx(() => [
                  (_unref(isShowBarcode))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createVNode(Label, {
          label: _unref(t)('fields.notes')
        }, {
          default: _withCtx(({ id }) => [
            _createVNode(ValidationKeyObserver, { keys: "notes" }, {
              default: _withCtx(({ firstErrorMessage }) => [
                _createVNode(MultiLine, {
                  modelValue: formData.value.notes,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.notes) = $event)),
                  errors: firstErrorMessage,
                  id: id,
                  lines: 4
                }, null, 8, ["modelValue", "errors", "id"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["label"]),
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createVNode(Button, {
            onClick: _unref(close),
            size: "lg",
            "button-type": "outline"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.actions.cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(Button, {
            onClick: save,
            size: "lg"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.actions.save')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})